import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled, { css } from 'styled-components'
import type { SearchTileDensity } from 'components/SearchKit/SearchTiles/searchTileDensity'
import { _searchTileContainerQueryUp } from './_SearchTileBase'

const Container = styled.div<{ $density: SearchTileDensity }>`
  grid-area: pricing;
  display: flex;
  flex-direction: row;
  gap: ${rem(12)};
  align-items: end;
  ${props => props.$density === 'compact' && css`
    justify-content: space-between;
  `}

  ${_searchTileContainerQueryUp.tablet} {
    ${props => props.$density === 'compact' ?
      css`
        flex-direction: row;
        gap: ${rem(12)};
        align-items: end;
      ` :
      css`
        flex-direction: column;
        gap: ${rem(8)};
        align-items: stretch;
      `}
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    flex-direction: row;
    gap: ${rem(12)};
    align-items: end;
  }

  ${_searchTileContainerQueryUp.desktop} {
    ${props => props.$density === 'compact' ?
      css`
        flex-direction: row;
        gap: ${rem(12)};
        align-items: end;
      ` :
      css`
        flex-direction: column;
        gap: ${rem(8)};
        align-items: stretch;
      `}
  }
`

const Details = styled.div<{ $density: SearchTileDensity }>`
  flex-grow: 1;
  min-width: 0;

  ${_searchTileContainerQueryUp.tablet} {
    ${props => props.$density !== 'compact' && css`
      min-width: ${rem(200)};
    `}
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    min-width: 0;
  }

  ${_searchTileContainerQueryUp.desktop} {
    ${props => props.$density !== 'compact' && css`
      min-width: ${rem(200)};
    `}
  }
`

const Action = styled.div<{ $density: SearchTileDensity }>`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  min-width: fit-content;
  max-width: ${rem(200)};

  ${_searchTileContainerQueryUp.tablet} {
    ${props => props.$density !== 'compact' && css`
      flex-grow: 1;
    `}
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    flex-grow: 0;
  }

  ${_searchTileContainerQueryUp.desktop} {
    ${props => props.$density !== 'compact' && css`
      flex-grow: 1;
    `}
  }

  &:empty {
    display: none;
  }
`

interface Props extends PropsWithChildren {
  action: ReactElement | false
  /**
   * @default default
   */
  density?: SearchTileDensity
}

function _SearchTilePricing({ children, action, density = 'default' }: Props) {
  return <Container $density={density}>
    <Details $density={density}>{children}</Details>
    {!!action && <Action $density={density}>{action}</Action>}
  </Container>
}

export default _SearchTilePricing
